import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=5cc70456&scoped=true"
import script from "./PopupMenu.vue?vue&type=script&lang=js"
export * from "./PopupMenu.vue?vue&type=script&lang=js"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=5cc70456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc70456",
  null
  
)

export default component.exports